
        var result = require("!!../../../node_modules/style-loader/index.js!../../../node_modules/css-loader/index.js!./callcenter.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/admin/consola_call/callcenter.component.css
// module id = 434
// module chunks = 0